import SearchComponent from "./SearchComponent.vue";
export default SearchComponent;
